import { BOARD_SIZE } from "../constants";
import { hasWallBetween } from "./movement";

const sameCells = (cell, otherCell) => cell.row === otherCell.row && cell.col === otherCell.col

const evaluateSettledCellsGroups = (separatedCellsGroups) =>
  separatedCellsGroups.map((cells) => {
    const stones = cells.map((cell) => cell.stone).filter((stone) => stone !== null)

    // If there are no stones, group is irrelevant.
    if (stones.length === 0) return { cells, settled: true }

    const players = [...new Set(stones)]

    // If all cells are occupied by stones of different players, stones are blocked.
    if (stones.length === cells.length && players.length > 1) return { cells, settled: true }

    // If there is more than one player, group is not settled.
    if (players.length > 1) return { cells, settled: false }

    // If there is only one player, group is settled and points are counted.
    return { cells, settled: true, player: players[0], points: cells.length }
  })

export const findSeparatedCells = (board, walls) => {
  const groups = [];

  for (let row = 0; row < BOARD_SIZE; row++) {
    for (let col = 0; col < BOARD_SIZE; col++) {
      const cell = { row, col, stone: board[row][col] }

      // Find all groups that this cell connects to
      const connectedGroups = groups.filter((group) =>
        group.some((groupCell) => {
          const left = { row: row - 1, col }
          const up = { row, col: col - 1 }

          if (sameCells(groupCell, left)) return !hasWallBetween(walls, cell.row, cell.col, left.row, left.col)
          if (sameCells(groupCell, up)) return !hasWallBetween(walls, cell.row, cell.col, up.row, up.col)

          return false
        })
      )

      if (connectedGroups.length > 0) {
        // If we found connected groups, merge them all together
        let mergedGroup = [cell];

        connectedGroups.forEach(group => {
          mergedGroup = mergedGroup.concat(group)
        })

        // Remove the old groups that were merged
        connectedGroups.forEach(group => {
          const index = groups.indexOf(group)

          if (index !== -1) groups.splice(index, 1)
        })

        // Add the merged group
        groups.push(mergedGroup)
      } else {
        // If no connected groups found, create a new one
        groups.push([cell])
      }
    }
  }

  return evaluateSettledCellsGroups(groups)
}
